import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const OrganizationSettingsEmailDomainsViewTopBar = memo(() => {
	return <BaseTopBar showAIButton={false} />
})
OrganizationSettingsEmailDomainsViewTopBar.displayName = "OrganizationSettingsEmailDomainsViewTopBar"
